<template>
  <v-alert
    dense
    border="left"
    type="error"
    v-if="errors.length > 0"
  >
    <p
      class="pa-0 ma-0"
      v-for="(error, idx) in errors"
      :key="idx"
    >
      {{ error }}
    </p>
  </v-alert>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: []
    }
  },
  computed: {
    MESSAGE() {
      return 'message';
    }
  }
}
</script>

<style>

</style>
